// Configurazione delle variabili d'ambiente compatibile con browser e test
const isTestEnv =
  typeof process !== 'undefined' && process.env.NODE_ENV === 'test';

const getEnvVar = (key: string, fallback = ''): string => {
  // Nei test Jest, usa process.env
  if (isTestEnv && process.env) {
    return process.env[key] || fallback;
  }

  // Nel browser con Vite, usa import.meta.env
  // Usiamo try/catch per evitare errori in Jest
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - import.meta è disponibile solo in Vite, non in Jest
    if (import.meta?.env?.[key]) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - accesso dinamico a import.meta.env
      return import.meta.env[key] || fallback;
    }
  } catch {
    // In Jest, import.meta non è disponibile, usa process.env come fallback
    if (typeof process !== 'undefined' && process.env) {
      return process.env[key] || fallback;
    }
  }

  return fallback;
};

export const config = {
  API_URL: getEnvVar('VITE_API_URL', 'http://localhost:3000'),
  NODE_ENV: getEnvVar('VITE_ENV') || getEnvVar('VITE_NODE_ENV', 'development'),
  OPENAI_API_KEY: getEnvVar('VITE_OPENAI_API_KEY', ''),
  SENTRY_DSN: getEnvVar('VITE_SENTRY_DSN', ''),
  MONITOR_APK_URL: getEnvVar('VITE_MONITOR_APK_URL', ''),
};

/** Emails allowed to see legacy vapor migration UI (FE routes / nav only). */
const LEGACY_USERS_ADMIN_EMAILS = new Set([
  'muscogiuri.gabriele@live.it',
]);

/** Emails allowed to hard-delete be2025 users from admin UI. */
const USER_DELETE_ADMIN_EMAILS = new Set([
  'luca.bernardelli@become-hub.com',
  'muscogiuri.gabriele@live.it',
]);

/** Legacy vapor migration UI — allowlisted emails only (works in prod FE too). */
export const canAccessLegacyUsersAdmin = (
  email?: string | null
): boolean => {
  if (!email) return false;
  return LEGACY_USERS_ADMIN_EMAILS.has(email.trim().toLowerCase());
};

/** Hard-delete users in admin — allowlisted emails only. */
export const canDeleteAdminUser = (email?: string | null): boolean => {
  if (!email) return false;
  return USER_DELETE_ADMIN_EMAILS.has(email.trim().toLowerCase());
};
